import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

import Group from './Group';
import * as groupsActions from './reducer';

import './Groups.css';

export class GroupsComponent extends Component {
  static get propTypes() {
    return {
      fetching: PropTypes.bool,
      groups: PropTypes.arrayOf(PropTypes.shape({
        Id: PropTypes.number,
        Name: PropTypes.string,
        Active: PropTypes.bool
      })),
      onFetch: PropTypes.func.isRequired,
      updateGroup: PropTypes.func.isRequired,
      addGroup: PropTypes.func.isRequired
    };
  }

  constructor(props) {
    super(props);
    props.onFetch();

    this.state = {
      groups: props.groups,
      newGroupName: ''
    };
  }

  componentWillReceiveProps(props) {
    this.setState({
      groups: props.groups
    });
  }

  render() {
    const { fetching } = this.props;
    const { groups } = this.state;

    return (
      <div className="AdminGroups">
        { fetching && <div className="fetching">Getting groups</div> }
        { groups && this.renderGroups(groups) }
        {this.renderAddGroup()}
      </div>
    );
  }

  renderGroups(groups) {
    const { updateGroup } = this.props;

    return (<table className="Admin-table AdminGroups-table">
      <tbody>
        <tr>
          <th className="name">Name</th>
          <th className="active">Active</th>
          <th className="users">Users</th>
          <th className="commands">&nbsp;</th>
        </tr>
        { groups.map(g =>
          (<Group
            key={g.Id}
            group={g}
            allGroups={groups}
            onUpdateGroup={updated => updateGroup(updated)}
          />)
        )}
      </tbody>
    </table>);
  }

  renderGroup(group) {
    return (<tr className="AdminGroups-row" key={group.Id} />);
  }


  renderAddGroup() {
    const { newGroupName } = this.state;
    return (<form className="AdminGroups-addgroup" onSubmit={event => this.addNewGroup(event)}>
      <div className="addgroup-label">Add New Group</div>
      <input
        type="text"
        placeholder="New Group Name"
        className="AdminGroups-newgroupName"
        value={newGroupName}
        onChange={event => this.setState({ newGroupName: event.target.value })}
      />
      <input
        type="submit"
        className="AdminGroups-addgroupsubmit btn btn-submit"
        value="Add"
        disabled={!this.validateNewGroup()}
      />
    </form>);
  }

  validateNewGroup() {
    const { groups, newGroupName } = this.state;
    const newName = newGroupName.trim();

    return newName.length > 0
        && !groups.find(g => g.Name.toLowerCase() === newName.toLowerCase());
  }

  addNewGroup(event) {
    const { addGroup } = this.props;
    const { newGroupName } = this.state;
    event.preventDefault();

    addGroup(newGroupName.trim());
    this.setState({ newGroupName: '' });
  }
}

const mapStateToProps = state => ({
  fetching: state.admin.groups.fetching,
  groups: state.admin.groups.groups
});

const mapDispatchToProps = (dispatch) => {
  const {
    fetchGroupsIfNeeded,
    updateGroup,
    addGroup
  } = bindActionCreators(groupsActions, dispatch);

  return {
    onFetch: fetchGroupsIfNeeded,
    updateGroup,
    addGroup
  };
};

const Groups = withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(GroupsComponent));
export default Groups;



// WEBPACK FOOTER //
// ./src/admin/groups/Groups.js